<template>
  <div id="prod_cont">
  <div id="groups" class="group_cont" v-if="groups_bool">
    <ul>
      <li class="group_en" v-for="group of groups"><a @click="loadGroup" v-bind:id="group.g_id">{{ group.group | capitalize }}</a></li>
    </ul>
  </div>
    <div id="products" class="products" v-if="selected_group_bool">
      <ProductGroup
        :group="sel_group_id"
        :products="selected_group"
        :extra="extra"
      ></ProductGroup>
    </div>
  </div>
</template>
<script>
  import ProductGroup from '@/components/product_group'
  export default {
    name: 'Products',
    components: { ProductGroup },
    data (){
      return {
        show: 0,
        groups: this.groups,
        selected_group: null,
        products: this.products,
        selected_group_bool: null,
        groups_bool: null,
        sel_group_id: null,
        extra: null
      }
    },
    mounted () {
      this._fetchThings()
    },
    watch: {
      language: function () {
        this._fetchThings()
      }
    },
    methods: {
      loadGroup: function (event) {
        let el = event.target
        this.sel_group_id = el.id
        this.selected_group = this.products[el.id]
        this.extra = this.products[el.id][0].extra
        this.selected_group_bool = true
        let active = document.querySelector('.current')
        if (active)
          active.className = ""
        el.className = 'current'
      },
      _fetchThings: function () {
        let url = 'https://backend.schuett-biotec.de/'+this.language+'/products/'
        fetch(url)
        .then((response) => {
          return response.json()
        })
        .then((products) => {
          let grps = Object.keys(products)
          this.groups = grps.map(x => {
            return {
              g_id: x,
              group: products[x][0].group,
              extra: products[x][0].extra
            }
          }).sort((x,y) => {
            if(x.group > y.group)
              return 1;
            if(x.group < y.group)
              return -1;
            return 0;
          });
          this.products = products
          if(this.selected_group_bool){
            this.selected_group = products[this.sel_group_id]
            this.extra = products[this.sel_group_id][0].extra
          }
        })
        .catch((err) => {
          console.log(err)
        })
        this.groups_bool = true
      }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return '';
        let str = value.toString();
        var firstLetterRx = /(^|\s|[-])[a-z]/g;
        return str.replace(firstLetterRx, str => {
          return str.toUpperCase();
        });
      }
    }
  };
</script>
<style scoped>
  h1,h2 {
    color: black;
  }
  #prod_cont {
    color: black;
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: 1fr 1fr;
    grid-template-columns: [groups] 50% [prods];
  }
  ul {
    list-style: none;
  }
  li {
    color: black;
  }
  #groups {
    -ms-grid-row:1;
    -ms-grid-column:1;
    grid-column: groups;
  }
  #products {
    -ms-grid-row:1;
    -ms-grid-column:2;
    grid-column: prods;
  }
  .group_en {
    cursor: pointer;
  }
  li ul {
    display: inline-block;
  }
  .wing {
    color: black;
    padding-left: -1em;
  }
  .wing:before {
    content: "•";
    color: red;
    padding-right: 5px;
  }
  .current {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// src/components/products.vue